export default __webpack_public_path__ + "static/media/pencil.227fba5a.svg";